import axios from 'axios'
import { DASHBOARD_STATISTICS, USER_TOKEN } from "./CONSTANTS";

export const getDashboardStatistics = () => {
  console.info("utilsServices > getDashboardStatistics...");
  return new Promise((resolve, reject) => {
      axios
      .get(DASHBOARD_STATISTICS(),{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};